import { useState } from "react";
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter } from "@nextui-org/react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

interface CreateLimitationModalProps {
  isOpen: boolean;
  onOpenChange: () => void;
  onSubmit: (data: { title: string; description: string; resolution: string }) => void;
}

export default function CreateLimitationModal({
  isOpen,
  onOpenChange,
  onSubmit,
}: CreateLimitationModalProps) {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [resolution, setResolution] = useState("");

  const handleSubmit = () => {
    onSubmit({ title, description, resolution });
    setTitle("");
    setDescription("");
    setResolution("");
    onOpenChange();
  };

  return (
    <Modal 
      isOpen={isOpen} 
      onOpenChange={onOpenChange}
      className="bg-secondary"
      size="2xl"
    >
      <ModalContent>
        <ModalHeader className="text-xl">Add New Limitation</ModalHeader>
        <ModalBody className="flex flex-col gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Title</label>
            <Input
              value={title}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTitle(e?.target?.value)}
              placeholder="Enter limitation title"
              className="w-full"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Description</label>
            <Textarea
              value={description}
              onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setDescription(e?.target?.value)}
              placeholder="Describe your limitation"
              className="w-full"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Resolution Steps</label>
            <Textarea
              value={resolution}
              onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setResolution(e?.target?.value)}
              placeholder="Steps to resolve or manage this limitation"
              className="w-full"
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={handleSubmit}
            disabled={!title || !description || !resolution}
          >
            Add Limitation
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}